import { render } from "./TurnoList.vue?vue&type=template&id=0eeab49e&scoped=true"
import script from "./TurnoList.vue?vue&type=script&lang=js"
export * from "./TurnoList.vue?vue&type=script&lang=js"

import "./TurnoList.vue?vue&type=style&index=0&id=0eeab49e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eeab49e"]])

export default __exports__